{
  "w": 16,
  "h": 24,
  "rows": [
    "................",
    "........G.......",
    "........G.......",
    ".......WGW......",
    ".......WGW......",
    "......WWWWW.....",
    "......WGGGW.....",
    "......GGGGG.....",
    ".....WWWgWWW....",
    ".....WGGGGGW....",
    "....WWWWWWWWW...",
    "....WGGGGGGGW...",
    "....ggggggggg...",
    ".....GGGGGGG....",
    "....GGGGGGGGG...",
    "...GGGGGGGGGGG..",
    ".......RR.......",
    ".......RR.......",
    ".......RR.......",
    ".......RR.......",
    ".......RR.......",
    ".......RR.......",
    ".......RR.......",
    "......WWWWW....."
  ],
  "legend": {
    "G": "C.B_GREEN",
    "g": "C.GREEN",
    "R": "C.RED",
    "W": "C.B_WHITE"
  }
}
